import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=1643da3d"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=1643da3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports